import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Preview", -1)
const _hoisted_3 = {
  key: 1,
  class: "flex justify-between items-center h-6"
}
const _hoisted_4 = { class: "ql-formats" }
const _hoisted_5 = { class: "ql-formats" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    value: "ordered"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    value: "bullet"
  }),
  /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, [
    /*#__PURE__*/_createElementVNode("option", { selected: "" }),
    /*#__PURE__*/_createElementVNode("option", { value: "center" }),
    /*#__PURE__*/_createElementVNode("option", { value: "right" }),
    /*#__PURE__*/_createElementVNode("option", { value: "justify" })
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "flex self-center cursor-pointer"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "self-start text-sm text-red-600 w-full"
}

import Editor, { EditorSelectionChangeEvent } from "primevue/editor"
import { computed, ref, watch, onMounted } from "vue"
import Quill from "quill"
import { ExclamationCircleIcon } from "@heroicons/vue/solid"
import { PencilAltIcon } from "@heroicons/vue/outline"
import { useAgencyThemeStore } from "@/stores/agency-theme"

interface EditorModuleTypes {
    "emoji-toolbar": boolean
    imageResize?: {
        displaySize: boolean
    }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsRichTextEditor',
  props: {
    modelValue: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "",
    },
    errorMessage: {
        type: String,
        default: "",
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    isHiddenToolbar: {
        type: Boolean,
        default: false,
    },
    inline: {
        type: Boolean,
        default: false,
    },
    isPreviewVisible: {
        type: Boolean,
        default: false,
    },
},
  emits: ["update:modelValue", "load", "disableValidationError"],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "5c61aff2": (linkColor.value)
}))

const agencyTheme = useAgencyThemeStore()

const props = __props

const emit = __emit

const quill = ref()
const textFormats = ["bold", "italic", "underline", "strike"]
const mediaFormats = ["link", "image", "video"]
const isContentFocused = ref(!props.isPreviewVisible)
const linkColor = computed(() => agencyTheme?.agencyTheme?.linkColor || "#0090BE")

const model = computed({
    get: () => props.modelValue,
    set: (value) => {
        if (isContentFocused.value) {
            value = setLinkColor(value)
            emit("update:modelValue", value)
        }
    },
})
const errorStyle = computed(() => (props.errorMessage.length ? "error-style" : ""))
const toolbarStyle = computed(() => (props.isHiddenToolbar ? "hideToolbar" : ""))
const inlineStyle = computed(() => (props.inline ? "w-[512px]" : "w-full"))
const isPreview = ref(props.isPreviewVisible)
const isReadonlyEditor = ref(props.readonly)

const editorModules = ref<EditorModuleTypes>({
    "emoji-toolbar": isPreview.value,
    imageResize: { displaySize: true },
})

function setLinkColor(value: string) {
    if (value.includes("<a")) {
        const regex = /<a.*?href="(.*?)".*?>(.*?)<\/a>/g
        const matches = value.matchAll(regex)
        for (const match of matches) {
            const link = match[0].split("<a")[1]
            const linkColorStyle = `style="color: ${linkColor.value}"`
            value = value.replace(link, ` ${linkColorStyle} ${link}`)
        }
    }
    return value
}

function editorLoad(editor: EditorSelectionChangeEvent) {
    quill.value = (editor as unknown as { instance: Quill }).instance
    emit("load", quill.value)
}

function setPreview(value?: boolean) {
    isPreview.value = value || !isPreview.value
    isReadonlyEditor.value = value || !isReadonlyEditor.value
    setEditorImageResize()
}

function disableValidationError() {
    emit("disableValidationError")
}

function onSelectionChange(editor: EditorSelectionChangeEvent) {
    if (isPreview.value) {
        return
    }
    isContentFocused.value = editor.range !== null
    if (isContentFocused.value) {
        emit("update:modelValue", editor.htmlValue)
    }
}

function setEditorImageResize() {
    if (isPreview.value) {
        delete editorModules.value.imageResize
        isContentFocused.value = false
    } else {
        editorModules.value.imageResize = { displaySize: true }
    }
}

onMounted(() => {
    setEditorImageResize()
})

watch(
    () => props.isPreviewVisible,
    (value) => {
        setPreview(value)
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['relative', inlineStyle.value])
    }, [
      (_openBlock(), _createBlock(_unref(Editor), {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
        key: editorModules.value.imageResize?.displaySize?.toString(),
        "editor-style": "height: 201px",
        placeholder: __props.placeholder,
        modules: editorModules.value,
        class: _normalizeClass([errorStyle.value, toolbarStyle.value]),
        readonly: isReadonlyEditor.value,
        onLoad: editorLoad,
        onClick: disableValidationError,
        onSelectionChange: onSelectionChange
      }, {
        toolbar: _withCtx(() => [
          (isPreview.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", {
                  class: "flex self-center cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setPreview()))
                }, [
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-5 w-5 text-primary-color-600",
                    "aria-hidden": "true"
                  })
                ])
              ]))
            : (!__props.isHiddenToolbar)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_4, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(textFormats, (format) => {
                        return _createElementVNode("button", {
                          key: format,
                          class: _normalizeClass(`ql-${format}`)
                        }, null, 2)
                      }), 64))
                    ]),
                    _createElementVNode("span", _hoisted_5, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mediaFormats, (format) => {
                        return _createElementVNode("button", {
                          key: format,
                          class: _normalizeClass(`ql-${format}`)
                        }, null, 2)
                      }), 64))
                    ]),
                    _hoisted_6
                  ]),
                  (props.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(ExclamationCircleIcon), {
                          class: "h-5 w-5 text-red-600",
                          "aria-hidden": "true"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_8))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder", "modules", "class", "readonly"]))
    ], 2),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})